import { Col, Row, Table, TableProps } from 'antd';
import {
  IAssessmentAttempt,
  IAssessmentQuestion
} from 'interfaces/assessments';
import { ShowButton, TagField, TextField } from '@refinedev/antd';
import { formatDate } from 'services/date';
import { showTotalResults } from 'utils/show-total-results';
import { tagColorByStatus } from 'utils/statusColorMapping';
import { translateAssessmentAttemptStatus } from 'services/assessments';

interface AssessmentQuestionListProps {
  tableProps: TableProps<IAssessmentAttempt>;
}

export const ObjectiveAttemptsTable = ({
  tableProps
}: AssessmentQuestionListProps) => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            {...tableProps}
            rowKey="id"
            pagination={{
              ...tableProps.pagination,
              showTotal: showTotalResults
            }}
          >
            <Table.Column
              dataIndex={['user', 'full_name_or_name']}
              key="student"
              title="Aluno"
              render={value => <TextField value={value} />}
            />

            <Table.Column
              dataIndex={['user', 'email']}
              key="email"
              title="E-mail do aluno"
              render={value => <TextField value={value} />}
            />

            <Table.Column
              title="Iniciada em"
              dataIndex="created_at"
              key="created_at"
              render={value =>
                value ? (
                  <TextField value={formatDate(value, 'DD/MM/YYYY')} />
                ) : (
                  '--'
                )
              }
            />

            <Table.Column
              title="Finalizada em"
              dataIndex="completed_at"
              key="completed_at"
              render={value =>
                value ? (
                  <TextField value={formatDate(value, 'DD/MM/YYYY')} />
                ) : (
                  '--'
                )
              }
            />

            <Table.Column
              dataIndex="score"
              key="score"
              title="Nota"
              align="center"
              render={value => <TextField value={value ?? '--'} />}
            />

            <Table.Column
              dataIndex="status"
              key="status"
              title="Status"
              render={value => (
                <TagField
                  color={tagColorByStatus(value)}
                  value={translateAssessmentAttemptStatus(value)}
                />
              )}
            />

            <Table.Column
              title="Ações"
              dataIndex="actions"
              align="center"
              render={(_, record: IAssessmentQuestion) => {
                return (
                  <ShowButton
                    resource="assessments/attempts"
                    hideText
                    size="small"
                    recordItemId={record.id}
                  />
                );
              }}
            />
          </Table>
        </Col>
      </Row>
    </>
  );
};
